const CLE = "airthermo:son-micro";

export const sonMicroActif = () => localStorage.getItem(CLE) !== "off";
export const reglerSonMicro = (actif) => localStorage.setItem(CLE, actif ? "on" : "off");

let ctx = null;

export function jouerPop() {
  if (!sonMicroActif()) return;
  const Audio = window.AudioContext || window.webkitAudioContext;
  if (!Audio) return;
  ctx = ctx || new Audio();
  const t = ctx.currentTime;
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = "sine";
  osc.frequency.setValueAtTime(420, t);
  osc.frequency.exponentialRampToValueAtTime(1150, t + 0.07);
  osc.frequency.exponentialRampToValueAtTime(680, t + 0.16);
  gain.gain.setValueAtTime(0.0001, t);
  gain.gain.exponentialRampToValueAtTime(0.35, t + 0.015);
  gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.2);
  osc.connect(gain).connect(ctx.destination);
  osc.start(t);
  osc.stop(t + 0.22);
  const bulle = ctx.createOscillator();
  const g2 = ctx.createGain();
  bulle.type = "triangle";
  bulle.frequency.setValueAtTime(1600, t + 0.09);
  bulle.frequency.exponentialRampToValueAtTime(2400, t + 0.13);
  g2.gain.setValueAtTime(0.0001, t + 0.09);
  g2.gain.exponentialRampToValueAtTime(0.12, t + 0.1);
  g2.gain.exponentialRampToValueAtTime(0.0001, t + 0.17);
  bulle.connect(g2).connect(ctx.destination);
  bulle.start(t + 0.09);
  bulle.stop(t + 0.18);
}
